import { Component } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-get-in-touch',
  templateUrl: './get-in-touch.component.html',
  styleUrl: './get-in-touch.component.scss'
})
export class GetInTouchComponent {
  constructor() { }

  ngOnInit(): void {
    // Set background images
    if ($("[data-bg-src]").length > 0) {
      $("[data-bg-src]").each(function () {
        const src = $(this).attr("data-bg-src");
        $(this).css("background-image", "url(" + src + ")");
        $(this).removeAttr("data-bg-src").addClass("background-image");
      });
    }
  }
}
